import { NgClass, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
let uid = 0;
/**
 * Sample usage:
 *
 *     <expandable expandableTitle="Title">
 *         Lorem ipsum dolor
 *     </expandable>
 */
@Component({
    selector: 'expandable',
    templateUrl: './expandable.html',
    styleUrls: ['./expandable.scss'],
    standalone: true,
    imports: [ZippyModule, NgClass, NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpandableComponent {
    /**
     * Title
     */
    @Input()
    expandableTitle?: string;
    /**
     * Zippy id
     */
    @Input()
    expandableId?: string | (string | number)[];
    @Input()
    expandableIcon?: string;
    @Input()
    openAtStart?: boolean = false;
    @Input()
    addBorder = true;
    /**
     * Default zippy id
     */
    readonly defaultId = `expandable${uid++}`;
    get zippyId() {
        return this.expandableId || this.defaultId;
    }
}
